import * as React from 'react';

import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import PageSectionCtaWithoutImage from 'components/page/sections/page-section-cta-without-image';
import SliderBox from 'components/slider-box/slider-box';
import Table from 'components/table/table';
import { FormattedText } from 'components/typography';

import { getPropsSectionFourContainer } from './section-four-container.props';

export const SectionFourContainer: React.FC = () => {
  const props = getPropsSectionFourContainer();
  return (
    <>
      <PageSectionCtaWithoutImage
        titleElement={props.sections.one.titleElement}
        text={
          <CtaBox align="start">
            <CtaBoxText>{props.sections.one.text}</CtaBoxText>
            <br />
            <SliderBox
              title={props.sections.one.whatIsAggregating.title}
              content={props.sections.one.whatIsAggregating.content}
              align="center"
            />
          </CtaBox>
        }
        imageText={
          <GoodToKnow
            color="primary"
            title={props.sections.one.goodToKnow.title}
            content={props.sections.one.goodToKnow.content}
          />
        }
        columnLeft={{ size: ColumnsSize['1/3'] }}
        columnRight={{ size: ColumnsSize['2/3'] }}
        color="transparent"
      />
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem verticalAlign="stretch" center={true} size={ColumnsSize['2/3']}>
            <FormattedText>
              <Table rows={props.sections.two.table()} />
            </FormattedText>
          </ColumnsItem>
        </Columns>
      </PageSection>
    </>
  );
};
